{
    const template = `
        <style>
        .cookie{
            color:#fff;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
        }
        .cookie a{
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            color:#fff;
            text-decoration:none;
            display:inline;
            border-bottom:1px solid #fff;
        }
        .title{
            display:inline;
        }
        .dn{
            display:none !important;
        }
        .cookie{
            position:fixed;
            bottom:0;
            left:0;
            width:100%;
            background-color:rgba(0,0,0,.7);
            display:-webkit-box;
            display:-ms-flexbox;
            display:flex;
            -webkit-box-pack:center;
            -ms-flex-pack:center;
            justify-content:center;
            -webkit-box-align:center;
            -ms-flex-align:center;
            align-items:center;
            padding:24px 0;
            font-family:"Noto Sans TC","Helvetica Neue",Arial,sans-serif;letter-spacing:1px;
            font-weight:400;
            font-size:16px;
            z-index:99999;
            -webkit-animation:fadeUp 1.5s forwards cubic-bezier(.22,1,.36,1);animation:fadeUp 1.5s forwards cubic-bezier(.22,1,.36,1)
        }
        @-webkit-keyframes fadeUp{
            from{
                -webkit-transform:translateY(100%);
                transform:translateY(100%)
            }
            to{
                -webkit-transform:translateY(0);
                transform:translateY(0)
            }
        }
        
        @keyframes fadeUp{
            from{
                -webkit-transform:translateY(100%);
                transform:translateY(100%)
            }
            to{
                -webkit-transform:translateY(0);
                transform:translateY(0)
            }
        }
        .btn-agree-cookie{
            background-color:#fff;
            color:#777;
            border-radius:5px;
            padding:6px 12px;
            margin-left:24px;
            cursor:pointer;
            -webkit-transition:.3s;transition:.3s
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
        }
        .btn-agree-cookie:hover{
            background-color:#ddd
        }
        @media (max-width:991px){
            .cookie{
                font-size:14px;
                padding:20px 12px;
                -webkit-box-orient:vertical;
                -webkit-box-direction:normal;
                -ms-flex-direction:column;
                flex-direction:column;
            }
            .title{
                width:530px;
            }
            .btn-agree-cookie{
                margin:12px 0 0;
            }
        }
        
        @media (max-width:540px){
            .cookie{
                font-size:12px;
                line-height:20px;
                padding:12px;
            }
            .title{
                width:100%;
            }
            .btn-agree-cookie{
                margin:8px 0 0;
                padding:12px 24px;
                font-size:14px
            }
        }
        </style>   
        
        <div class="cookie">
            <div class="title">為提供您最優質的網站體驗，本網站使用cookies持續優化用戶體驗，若您繼續瀏覽即表示同意本站
            <span><a href="/app/member-center/privacy.html">隱私權政策</a></span>
            <span><div class="title">。</div></span>
            </div>
            
            <div class="btn-agree-cookie">我知道了</div>
        </div>
    `;
    customElements.define('eh-cookie', class extends HTMLElement {
        constructor() {
            super();
            const shadowRoot = this.attachShadow({mode: 'open'});
            shadowRoot.innerHTML = template;

            checkCookie();

            function checkCookie(){
                let cookie = getCookie("eh-expires")
                const cookieWrap  = shadowRoot.querySelector('.cookie');
                if (cookie != undefined && Number.isInteger(parseInt(cookie)) && parseInt(cookie) > Date.now()){
                    cookieWrap.classList.add("dn")
                }else{
                    setCookie();
                }
            }

            function setCookie() {
                const btnAgree  = shadowRoot.querySelector('.btn-agree-cookie');
                const cookieWrap  = shadowRoot.querySelector('.cookie');

                btnAgree.addEventListener("click",function(){
                    cookieWrap.classList.add("dn")
                    let d = new Date();
                    let year = d.getFullYear();
                    let month = d.getMonth();
                    let day = d.getDate();

                    let fulldate = new Date(year + 3, month, day);
                    document.cookie = "eh-expires="+fulldate.getTime()+"; path=/; max-age="+fulldate.getTime()+"; expires="+ fulldate.getTime();
                })
            }

            function getCookie(name){
                var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
                if (arr != null) return unescape(arr[2]); return null;
                
            }
        }
    });
}
